import type { FunctionComponent } from 'react';
import QuestionInterface from '../../../interfaces/question';
import Question from '../Question/Question';
import * as styles from './MultipleDynamic.module.css';

export interface MultipleDynamicProps {
  questions: QuestionInterface[];
}

const MultipleDynamic: FunctionComponent<MultipleDynamicProps> = ({ questions }) => (
  <div className={styles.multipleDynamicContainer}>
    {questions.map((q) => (
      <Question question={q} key={`dynamic-${q.id}`} />
    ))}
  </div>
);

export default MultipleDynamic;
